import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { BaseComponent } from '~/modules/base/BaseComponent';
import { IS_SP } from '~/const/config';
gsap.registerPlugin(ScrollToPlugin);
/**
 * アンカー処理をするクラス
 */
class Anchor extends BaseComponent {
  constructor(el) {
    super(el);
  }
  onClick(e) {
    e.preventDefault();

    const offset = IS_SP ? 0 : 0;
    const $section = document.querySelector(this.DOM.el.getAttribute('href'));
    const y = $section.offsetTop;

    gsap.to(window, {
      duration: 0.4,
      scrollTo: {
        y: y - offset
      }
    });
  }
}

/**
 * アンカーインスタンスの生成
 */
export class Anchors {
  constructor() {
    this.DOM = {};
    this.DOM.links = document.querySelectorAll('a');
    this.anchors = [];

    this.init();
  }
  init() {
    for (const link of this.DOM.links) {
      if (/^#[a-z]+/.test(link.getAttribute('href'))) {
        this.anchors.push(new Anchor(link));
      }
    }
  }
  destroy() {
    for (const anchor of this.anchors) {
      anchor.dispose();
    }
  }
}
